import {store} from './store'
//import router from './../router/index'
//import {Models} from './models'
import Security from './security'
import notie from 'notie/dist/notie';

//let totalRecords = 0

const Utils:any = {

    parseToSlovakDateTime(dateTimeStr) {
        // Parse the datetime string into a Date object
        let date = new Date();
        if (typeof dateTimeStr == "undefined"){
          date = new Date();
        }else{
           date = new Date(dateTimeStr);
        }
        date = this.getCETorCESTDate(date)
        //console.log(dateTimeStr)
        // Define options for formatting the date
        const dateOptions: Intl.DateTimeFormatOptions = {
          year: "numeric",
          month: '2-digit',
          day: '2-digit',
      //    hour: '2-digit',
      //    minute: '2-digit',
      //    second: '2-digit', // Include seconds for datetime
        };
  
        // Define options for formatting time according to Slovak locale
        const timeOptions: Intl.DateTimeFormatOptions = {
          hour: '2-digit',
          minute: '2-digit',
        };
  
        // Using 'sk-SK' locale for date
        const formattedDate = new Intl.DateTimeFormat('sk-SK', dateOptions).format(date);
  
        // Using 'sk-SK' locale for time
        const formattedTime = new Intl.DateTimeFormat('sk-SK', timeOptions).format(date);
       
        // Combine formatted date and time with separator (e.g., " ")
        return `${formattedDate.replace(/\s/g, "")} ${formattedTime}`;
    },
    formatToSlovak(dateStr){
        let date = new Date(dateStr);
        date = this.getCETorCESTDate(date);

        const dateOpt: Intl.DateTimeFormatOptions = {
          year: "numeric",  // Display year as a number (e.g., 2024)
          month: '2-digit',  // Display month with two digits (e.g., 03 for March)
          day: '2-digit',   // Display day with two digits (e.g., 14)
          hour: '2-digit',   // Display hour with two digits (e.g., 13 for 1 PM)
          minute: '2-digit', // Display minute with two digits (e.g., 48)
          hour12: false,     // Use 24-hour format (not AM/PM)
        };
  
  
        // Using 'sk-SK' locale
        return new Intl.DateTimeFormat('sk-SK', dateOpt).format(date);
    },
    parseToSlovakDate(dateTimeStr) {
        //console.log('parseToSlovakDate:',dateTimeStr)
        const date = new Date(dateTimeStr);
  
        // Define options for formatting the date
        const dateOptions: Intl.DateTimeFormatOptions = {
          year: "numeric",
          month: '2-digit',
          day: '2-digit',
        };
        const formattedDate = new Intl.DateTimeFormat('sk-SK', dateOptions).format(date);
        
        return `${formattedDate}`.replace(/\s/g, "");
    },
    createDateFromString(dateString: string): Date | null {
        // Split the date string into day, month, and year components
        const [dayString, monthString, yearString] = dateString.split(".");
      
        // Parse the components into integers
        const day = parseInt(dayString, 10);
        const month = parseInt(monthString, 10) - 1; // Adjust month (January = 0)
        const year = parseInt(yearString, 10);
      
        // Validate the date components
        if (
          isNaN(day) ||
          isNaN(month) ||
          isNaN(year) ||
          day < 1 ||
          day > 31 ||
          month < 0 ||
          month > 11 ||
          year < 0
        ) {
          return null; // Invalid date format or values
        }
      
        // Create the date object
        const date = new Date(year, month, day);
      
        // Check if the parsed date object matches the original format (avoid edge cases)
        if (
          date.getDate() !== day ||
          date.getMonth() !== month ||
          date.getFullYear() !== year
        ) {
          return null; // Invalid date due to edge cases (e.g., Feb 30)
        }
      
        return date;
    },
    saveDate(newDate): Date {
        if (typeof newDate == "string"){
            newDate.replace(/\s/g, "");
            newDate = this.createDateFromString(newDate);
            //newDate = new Date(newDate);
            //console.log('New Date:',newDate)
        }
        const newDateTemp = new Date(newDate.getTime()); 
        newDateTemp.setDate(newDateTemp.getDate() + 1);
        //console.log('SAve Date:',newDateTemp)
        return newDateTemp;
    },
    updateOrderHistory() {
        //fetch order history
        //console.log('order history id:',store.order.id)
        fetch(store.Api_url + "/v1/order-history?query=order_id:" + store.order.id, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                notie.alert({
                  type: 'error',
                  text: 'Nepodarilo sa načítať prehľad stavov',
                  position: "bottom"
                })          
              } else {
                
                if(responseData.data != null){
                  store.orderHistory = responseData.data;
                  //console.log('order history:');
                  //console.log(responseData)
                } else{
                  //console.log('there is no order history ');
                  store.orderHistory = []
                  //console.log('order history:');
                }
  
                //this.updateStatuses();
              }
            });
    },
    changeState(s: number){
        //if(confirm("Naozaj chcete zmeniť stav?")){
          fetch(store.Api_url + "/set-state/" + store.order.id+ "/" + s, Security.requestOptions("POST"))
              .then((response) => response.json())
              .then((responseData) => {
                if (responseData.error) {
                  console.log("error:", responseData.message);
                  notie.alert({
                    type: 'error',
                    text: 'Stav objednávky sa nepodarilo zmeniť',
                    position: "bottom"
                  })          
                } else {
                  store.orderHistory = responseData.data;
                  //this.updateStatuses();
                  const lastHistory = store.orderHistory[store.orderHistory.length - 1];
                  store.order.currentState = lastHistory.state;
                  store.order.modifiedAt = lastHistory.changeDate;
                  store.order.modifiedUser = lastHistory.user;
                }
              });
        //}
  
    },
  
    getOrderStates() {
        fetch(store.Api_url + "/v1/order-state", Security.requestOptions("GET"))
        .then((response) => response.json())
        .then((responseData) => {
            if (responseData.error) {
              //console.log("error:", responseData.data.message);
              //this.$emit('error', responseData.message);
            } else {
              if(responseData.data != null){
                 store.orderStates = responseData.data;
              }else{
                store.orderStates = []
              }
              //if (store.order.id === 0) {
              //    store.order.currentState = store.orderStates[0]
              //    console.log("GetState:", store.order.currentState);
              //}
            }
        });
    },

    getAttTypes() {
      fetch(store.Api_url + "/v1/attachment-type", Security.requestOptions("GET"))
      .then((response) => response.json())
      .then((responseData) => {
          if (responseData.error) {
            notie.alert({
              type: 'error',
              text: 'Nepodarilo sa načítať typy príloh: '+responseData.data.message,
              position: "bottom"
            })          
          } else {
    
            if(responseData.data != null){
              store.attTypes = responseData.data;
            } else{
              store.attTypes = []
            }
          }
      })
      .catch((error) => {
        notie.alert({
          type: 'error',
          text: "Nepodarilo sa načítať typy príloh: "+error
        })

      })
    },

    updateStockMovement(nameOfField:string,id:number) {
 
      //console.log('stock movement id:',store.order.id)
      fetch(store.Api_url + "/v1/stock-movement?query=deleted:0,"+nameOfField+":" + id, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //console.log("error:", responseData.message);
              notie.alert({
                type: 'error',
                text: 'Nepodarilo sa načítať pohyby ',
                position: "bottom"
              })          
            } else {
              
              if(responseData.data != null){
                store.stockMovements = responseData.data;
               
                //console.log(responseData)
              } else{
                //console.log('there is no order history ');
                store.stockMovements = []
               
              }

            }
          })
          .catch((error) => {
            notie.alert({
              type: 'error',
              text: "Nepodarilo sa načítať pohyby: "+error
            })
            //console.log("Error:", error);
          })
    },

    getAddTextAction(item:string) :string{
      return item + " bol(a) pridan(ý/á) do skladu"
    },
    getAddPackTextAction(product) :string{
      return "Balíček kusov s kódom "+ product.code +" a počtom kusov "+String(product.numberOfProd)+ " bol pridaný do skladu"
    },
    getDelTextAction(item:string) :string{
      return item + " bol(a) vyraden(ý/á) zo skladu"
    },
    getReservedOrderTextAction(item:string,orderCode:string) :string{
      return item + " bol rezervovaný pre objednávku "+orderCode
    },
    getCanceledReservationOrderTextAction(item:string,orderCode:string) :string{
      return "Rezervácia "+item+" pre objednávku "+orderCode+" bola zrušená "
    },
    getChangeLocationTextAction(item:string,location:string) :string{
      return item + " bol(a) presunut(ý/á) do "+location
    },
    getChangeNumberOfPiecesTextAction(difference:number,code:string) :string{
      if (difference > 0){
        return "Kusy s kódom "+code+" a počtom "+String(difference)+" boli pridané do balíka"
      }else{
        return "Kusy s kódom "+code+" a počtom "+String(difference*(-1))+" boli z balíka odobrané"
      }
    },
    getEventTextAction(item:string,event:string) :string{
      return item + " bola "+event
    },

    addStockMovement(data,field:string,typeOfAction:string,id:number) {
      
      if (typeOfAction == "ADD"){
        data.color =  "#22c55e"
      }
      if (typeOfAction == "DEL"){
        data.color =  "#ef4444"
      }
      if (typeOfAction == "CHA"){
        data.color =  "#f97316"
      }      
      //console.log('stock movement id:',store.order.id)
      fetch(store.Api_url + "/v1/stock-movement", Security.requestOptions("POST", data))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //console.log("error:", responseData.message);
              notie.alert({
                type: 'error',
                text: 'Údaje o pohybe neboli uložené',
                position: "bottom"
              })          
            } else {
              
              this.updateStockMovement(field,id)

            }
          });
    },

    printZplLabel(id:number, itemType:string){
      fetch(store.Api_url + "/generate_zpl/"+String(id)+"?type="+itemType, Security.requestOptions("GET"))
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.error) {
          
          notie.alert({
            type: 'error',
            text: "Štítok sa nepodarilo vytvoriť"
          })
        } else {
          
          this.updateStockMovement(itemType+"_id",id)
          notie.alert({
            type: 'success',
            text: "Štítok bol vytvorený a bude odoslaný do tlačiarne"
          })

        }
      })
      .catch((error) => {
        notie.alert({
          type: 'error',
          text: "Štítok sa nepodarilo vytvoriť: "+error
        })
        //console.log("Error:", error);
      })
    },

    changeEmailHistory(){
      fetch(store.Api_url + "/v1/email-history", Security.requestOptions("POST", store.emailHistory))
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.error) {
          console.log("error:", responseData.message);
          notie.alert({
            type: 'error',
            text: 'Údaje o zaslanom emaile neboli uložené do histórie',
            position: "bottom"
          })          
        } else {
          //console.log("Email History:", responseData);
          this.getEmailHistory(responseData.order.id) 
          
          //store.emailHistories = responseData.filter(obj => obj.order.id == store.order.id);

          //store.hasBeenEmailSent = true;
        }
      });   
    },
    sendingEmail(type: string,id: number){
      fetch(store.emailLink + "?type="+type+"&recipId=" + id,Security.requestOptions("GET"))
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.error) {
          notie.alert({
              type: 'error',
              text: responseData.message,
              position: "bottom"
            })
         // this.$emit('error', responseData.message);
        } else {
  
          store.emailHistory.createDate = new Date();
          //console.log("Email History Date:", store.emailHistory.createDate);
          store.emailHistory.order = store.order;
          store.emailHistory.subject = store.emailRecipient.glassType;
          store.emailHistory.user = store.user;
          store.emailHistory.whom = store.emailRecipient.name;
          
          Utils.changeEmailHistory()
          
          notie.alert({
                type: 'success',
                text: responseData.message,
                position: "bottom"
          });
        }
      })
    },
    // check, či pre daný dátum platí zimný, či letný čas
    isDSTInEffect(date: Date): boolean {
      // Create a new Date object with the same date but at 12:00 AM
      const midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);

      // Get the time zone offset in milliseconds
      const timezoneOffset = midnight.getTimezoneOffset();

      // Check if the offset is one hour more than the standard CET offset (GMT+01:00)
      return timezoneOffset === -60; // 60 = 1 hour
    },
    getCETDateAndTime(date: Date): Date{
      const utcDate = date.toUTCString();
    
      // Create a new Date object with UTC time and specify CET time zone
      return new Date(utcDate + " GMT-01:00");
    },
    getCESTDateAndTime(date: Date): Date{
      const utcDate = date.toUTCString();
         
      return new Date(utcDate + " GMT-02:00");
    },  
    getCETorCESTDate(date: Date):Date{

      if(this.isDSTInEffect(date)){
        return this.getCETDateAndTime(date)
      }else{
        return this.getCESTDateAndTime(date)
      }
    },
    minusOneHour(date: Date): Date {
      // Get the current hour
      const currentHour = date.getHours();
      // Calculate the new hour by adding one hour
      const newHour = (currentHour - 1) % 24; // Modulo 24 to keep the hour within the range 0-23
       // Set the new hour in the Date object
      date.setHours(newHour);
      // Return the modified Date object
      return date;
    },

    getMessageRoute(basicUrlMessage,routeParams): string {
      let routeByType = "" 
      if(routeParams.typ == "1"){
          routeByType = basicUrlMessage + ",unread:1"
      }
      if(routeParams.typ == "2"){
          // Show all unassigned messages from suppliers (supplier_id is not null and > 0)
          routeByType = basicUrlMessage + ",assigned:0,supplier_id__isnull:false"
      }   
      if(routeParams.typ == "3"){
          routeByType = basicUrlMessage + ",supplier_id:"+routeParams.id
      }   
      if(routeParams.typ == "4"){
        routeByType = basicUrlMessage + ",assigned:1,mark_id:"+routeParams.id
    }   
      return routeByType
    },

    getMessageCount(routeParams): Promise<number> {
      let routeByType = this.getMessageRoute(store.basicUrlMessage,routeParams)
      if(routeParams.typ == "3"){
        routeByType = store.basicUrlMessage + ",supplier_id:"+routeParams.id+",unread:1"
      }   
      const promise = fetch(`${store.Api_url}${routeByType}`, Security.requestOptions("GET"))

          .then(response => response.json())
          .then((data) => {
            return data.totalRecords;
          });
      return promise;  
      
    }
}

export default Utils;